import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable, map, startWith } from 'rxjs';
import { DatatableConfig } from 'src/app/config/DatatableConfig';
import { IAnyos, IPeriodos } from 'src/app/interfaces/portal-calificaciones';
import { IListaSeccionesReemplazoDocente, IObjSeccionReemplazoDocente, IReemplazos, IReqBodyCrearReemplazoDocente, IResCrearReemplazoDocente } from 'src/app/interfaces/reemplazo-docente';
import { PerfilamientoService } from 'src/app/services/perfilamiento/perfilamiento.service';
import { PortalCalificacionesService } from 'src/app/services/portal-calificaciones/portal-calificaciones';
import { ReemplazoDocenteService } from 'src/app/services/reemplazo-docente/reemplazo-docente.service';
import { UtilsFnService } from 'src/app/services/utils/utils-fn.service';

@Component({
  selector: 'app-view-reemplazo-docente-crear',
  templateUrl: './view-reemplazo-docente-crear.component.html',
  styleUrls: ['./view-reemplazo-docente-crear.component.scss']
})
export class ViewReemplazoDocenteCrearComponent implements OnInit {
  dtOptions: DataTables.Settings = { ...DatatableConfig.dtSortWithoutSearch }
  renderTable: boolean = false

  filtroAnyo: number = 0
  filtroPeriodo: number = 0
  filtroSede: number = 0
  filtroSeccion: number = 0
  filtroIdDocente: string = ''

  listaAnyo: Array<number> = []
  listaPeriodo: any = []
  listaSede: any = []
  listaSeccion: any = []

  filtrosCargados: any = {}

  tieneErrores: any = {}
  submitted: boolean = false
  activarTodos: boolean = true

  rolDaraCentral: boolean = false

  listaNombreDocentes: any = []
  searchCodDocenteForm = new FormControl('')
  searchNombreDocenteForm = new FormControl('')
  filteredNombreDocentes: Observable<Array<any>>
  filteredCodDocentes: Observable<Array<any>>

  listaNombreDocentesReemplazo: any = []
  searchCodDocenteReemplazoForm = new FormControl('')
  filteredCodDocentesReemplazo: Observable<Array<any>>

  nombreDocenteReemplazo: string = ''

  fechaInicioDocenteReemplazo: string | Date = ''
  fechaFinDocenteReemplazo: string | Date = ''

  listaSeccionesDocente: Array<any> = []

  parametrosForm = this.formBuilder.group({
    anyo: ['0', [Validators.required]],
    periodo: ['0', [Validators.required]],
    sede: ['0'],
    seccion: ['0'],
    idDocente: [''],
    nombreDocente: ['']
  })

  reemplazoDocenteForm = this.formBuilder.group({
    idDocenteReemplazo: ['']
  })

  infoModalTitulo: string = ''
  infoModalTexto: string = ''

  constructor(
    private _reemplazoDocente: ReemplazoDocenteService,
    private _portalServices: PortalCalificacionesService,
    private _perfilamiento: PerfilamientoService,
    private router: Router,
    private formBuilder: FormBuilder,
    private _utilsFn: UtilsFnService
  ) {
    // this.dtOptions = DatatableConfig.dtSortWithoutSearch
    let user = this._perfilamiento.getUsuario()
    if ( user.nombreRol === 'R_DARA_C' ) this.rolDaraCentral = true

    const routerData = this.router.getCurrentNavigation()?.extras?.state?.['data']
    if (routerData?.filtros) {
      this.filtrosCargados = routerData.filtros
    }

    this.filteredCodDocentes = this.searchCodDocenteForm.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', 'cod')),
    )
    this.filteredNombreDocentes = this.searchNombreDocenteForm.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', 'nombre')),
    )
    this.filteredCodDocentesReemplazo = this.searchCodDocenteReemplazoForm.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', 'codDocenteReemplazo')),
    )

    this.obtenerAnyos()
  }

  ngOnInit(): void {
    this.dtOptions = { ...DatatableConfig.dtSortWithoutSearch }
    setTimeout(() => {
      this.renderTable = true
    }, 500)
  }

  displayFnCodDocentes(docente: any): string {
    return docente?.codigo ?? '';
  }

  displayFnNombreDocentes(docente: any): string {
    return docente?.primerNombre ? `${docente.primerNombre ?? ''} ${docente.apellidoPat ?? ''} ${docente.apellidoMat ?? ''}` : '';
  }

  displayFnCodDocentesReemplazo(docente: any): string {
    return docente?.codigo ?? ''
  }

  private _normalizeValue(value: string): string {
    return value?.toLowerCase()?.normalize("NFD")?.replace(/[\u0300-\u036f]/g, '')
  }

  private _filter(value: string, type: string): string[] {
    if (typeof value != 'string') {
      return []
    }
    const filterValue = this._normalizeValue(value)
    if ( type === 'codDocenteReemplazo' ) {
      return this.listaNombreDocentesReemplazo.filter((docente: any) => this._normalizeValue(docente?.codigo)?.includes(filterValue) )
    }
    if ( type === 'cod' ) {
      return this.listaNombreDocentes.filter((docente: any) => this._normalizeValue(docente?.codigo)?.includes(filterValue) )
    } else {
      return this.listaNombreDocentes.filter((docente: any) => this._normalizeValue(`${docente?.primerNombre} ${docente?.apellidoPat} ${docente?.apellidoMat}`)?.includes(filterValue) )
    }
  }

  keypressNumber(event: any) {
    return this._utilsFn.keypressNumber(event)
  }

  resetearValidacion(tipo: string = 'default') {
    this.submitted = false
    this.tieneErrores["anyo"] = false
    this.tieneErrores["periodo"] = false
    this.tieneErrores["sede"] = false
    this.tieneErrores["idDocente"] = false
    this.tieneErrores["idDocenteReemplazo"] = false
    this.tieneErrores["fechaInicioDocenteReemplazo"] = false
    this.tieneErrores["fechaFinDocenteReeemplazo"] = false

    if ( tipo === 'inputSearchCodDocente' || tipo === 'inputSearchNombreDocente' ) {
      this.seleccionDocente(tipo)
    }
  }

  limpiarFiltros() {
    this.filtroAnyo = 0
    this.filtroPeriodo = 0
    this.listaPeriodo = []
    this.filtroSede = 0
    this.listaSede = []
    this.filtroSeccion = 0
    this.listaSeccion = []
    this.searchCodDocenteForm.patchValue('', {emitViewToModelChange: true, emitModelToViewChange: true, emitEvent: false})
    this.searchNombreDocenteForm.patchValue('', {emitViewToModelChange: true, emitModelToViewChange: true, emitEvent: false})
    this.searchCodDocenteReemplazoForm.patchValue('', {emitViewToModelChange: true, emitModelToViewChange: true, emitEvent: false})
    this.listaNombreDocentes = []
    this.listaNombreDocentesReemplazo = []
    this.filteredCodDocentes = this.searchCodDocenteForm.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', 'cod')),
    )
    this.filteredNombreDocentes = this.searchNombreDocenteForm.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', 'nombre')),
    )
    this.filteredCodDocentesReemplazo = this.searchCodDocenteReemplazoForm.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', 'codDocenteReemplazo')),
    )
    
    this.renderTable = false
    this.listaSeccionesDocente = []
    setTimeout(() => {
      this.renderTable = true
    }, 500);
  }

  limpiarFiltrosDocenteReemplazo() {
    this.fechaInicioDocenteReemplazo = ''
    this.fechaFinDocenteReemplazo = ''
    this.nombreDocenteReemplazo = ''

    this.searchCodDocenteReemplazoForm.patchValue(' ', {emitViewToModelChange: true, emitModelToViewChange: true, emitEvent: true})
    this.searchCodDocenteReemplazoForm.patchValue('', {emitViewToModelChange: true, emitModelToViewChange: true, emitEvent: true})
  }

  seleccionDocente(tipo: string) {
    const dataDocente: any = typeof this.searchCodDocenteForm.getRawValue() === 'object' ? this.searchCodDocenteForm.getRawValue() : this.searchNombreDocenteForm.getRawValue()
    if ( typeof this.searchCodDocenteForm.getRawValue() === 'object' && tipo === 'inputSearchCodDocente' && typeof this.searchNombreDocenteForm.getRawValue() !== 'object' ) {
      this.searchNombreDocenteForm.patchValue(dataDocente, {emitViewToModelChange: true, emitModelToViewChange: true, emitEvent: false})
    }
    if ( typeof this.searchNombreDocenteForm.getRawValue() === 'object' && tipo === 'inputSearchNombreDocente' && typeof this.searchCodDocenteForm.getRawValue() !== 'object' ) {
      this.searchCodDocenteForm.patchValue(dataDocente, {emitViewToModelChange: true, emitModelToViewChange: true, emitEvent: false})
    }

    if ( tipo === 'inputSearchCodDocente' && typeof this.searchCodDocenteForm.getRawValue() !== 'object' && typeof this.searchNombreDocenteForm.getRawValue() === 'object' ) {
      this.searchNombreDocenteForm.patchValue('', {emitViewToModelChange: true, emitModelToViewChange: true, emitEvent: false})
    }
    if ( tipo === 'inputSearchNombreDocente' && typeof this.searchNombreDocenteForm.getRawValue() !== 'object' && typeof this.searchCodDocenteForm.getRawValue() === 'object' ) {
      this.searchCodDocenteForm.patchValue('', {emitViewToModelChange: true, emitModelToViewChange: true, emitEvent: false})
    }
  }

  buscarDocenteReemplazo() {
    const docenteReemplazo: any = typeof this.searchCodDocenteReemplazoForm.getRawValue() === 'object' ? this.searchCodDocenteReemplazoForm.getRawValue() : ''
    if ( docenteReemplazo?.funcionarioId ) {
      this.nombreDocenteReemplazo = `${docenteReemplazo?.primerNombre} ${docenteReemplazo?.apellidoPat} ${docenteReemplazo?.apellidoMat}`
    }
  }

  fnCasePeriodo(): void {
    this.obtenerSedes(this.filtroAnyo, this.filtroPeriodo, 0);
    this.verificarYObtenerDocentesParaPeriodo();
  }
  
  fnCaseSede(): void {
    this.obtenerSecciones(this.filtroAnyo, this.filtroPeriodo, this.filtroSede);
    this.verificarYObtenerDocentesParaSede();
  }
  
  verificarYObtenerDocentesParaPeriodo(): void {
    if (Object.keys(this.filtrosCargados).length === 0 || (!this.filtrosCargados?.periodoId && this.filtrosCargados?.sedeId === 0)) {
      this.obtenerDocentes(this.filtroAnyo, this.filtroPeriodo);
    }
  }
  
  verificarYObtenerDocentesParaSede(): void {
    if (Object.keys(this.filtrosCargados).length === 0 || (!this.filtrosCargados?.sedeId && this.filtrosCargados?.seccionId === 0)) {
      this.obtenerDocentes(this.filtroAnyo, this.filtroPeriodo, this.filtroSede);
    }
  }

  cargarFiltros(filtro: string): void {
    if ( this.filtroAnyo === 0 && this.filtroPeriodo === 0 ) {
      return
    }

    switch (filtro) {
      case "anyo":
        this.obtenerPeriodos(this.filtroAnyo)
        break;
      case "periodo":
        this.fnCasePeriodo()
        break;
      case "sede":
        this.fnCaseSede()
        break;
      case "seccion":
        this.obtenerDocentes(this.filtroAnyo, this.filtroPeriodo, this.filtroSede, this.filtroSeccion)
        break;
      default:
        break;
    }
  }

  obtenerAnyos() {
    this._portalServices.obtenerListaAnhos(true).subscribe((res: IAnyos) => {
      this.listaAnyo = res.anyos
      if ( this.filtrosCargados?.anyo ) {
        this.filtroAnyo = this.filtrosCargados?.anyo
        delete this.filtrosCargados.anyo
      }
    })
  }

  obtenerDocentes(anyo: number, periodoId: number, sedeId: number = 0, seccionId: number = 0): void {
    this._reemplazoDocente.obtenerListaDocentesBackoffice(anyo, periodoId, sedeId, seccionId).subscribe((res: any) => {
      this.listaNombreDocentes = res

      this.filteredCodDocentes = this.searchCodDocenteForm.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value || '', 'cod')),
      )
      this.filteredNombreDocentes = this.searchNombreDocenteForm.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value || '', 'nombre')),
      )

      if ( sedeId === 0 && seccionId === 0 ) {
        this.listaNombreDocentesReemplazo = res
        this.filteredCodDocentesReemplazo = this.searchCodDocenteReemplazoForm.valueChanges.pipe(
          startWith(''),
          map(value => this._filter(value || '', 'codDocenteReemplazo')),
        )
      }

      if ( this.filtrosCargados?.dataDocente ) {
        this.searchCodDocenteForm.patchValue(this.filtrosCargados.dataDocente, {emitViewToModelChange: true, emitModelToViewChange: true, emitEvent: true})
        delete this.filtrosCargados.dataDocente
      } else if ( this.filtroSeccion === 0 && this.listaNombreDocentes.length === 0 ) {
        this.searchCodDocenteForm.patchValue(' ', {emitViewToModelChange: true, emitModelToViewChange: true, emitEvent: true})
        this.searchCodDocenteForm.patchValue('', {emitViewToModelChange: true, emitModelToViewChange: true, emitEvent: true})
      }
    })
  }

  obtenerPeriodos(filtroAnyo: number): void {
    this.filtroPeriodo = 0
    this.filtroSeccion = 0
    this.filtroSede = 0
    this.listaSede = []
    this.listaSeccion = []

    if ( filtroAnyo !== 0 ) {
      this.tieneErrores["anyo"] = false
      this._portalServices.obtenerListaPeriodos(filtroAnyo, true).subscribe(
        (res: IPeriodos) => {
          this.listaPeriodo = res.periodos
          if (this.filtrosCargados?.periodoId) {
            this.filtroPeriodo = this.filtrosCargados.periodoId
            if ( this.filtrosCargados.hasOwnProperty("dataDocente") ) {
              // this.obtenerDocentes(this.filtroAnyo, this.filtroPeriodo)
            }
            delete this.filtrosCargados.periodoId
          }
        }
      )
    }
  }

  obtenerSedes(anyo: number = 0, periodoId: number = 0, funcionarioId: number = 0): void {
    this.filtroSeccion = 0
    this.filtroSede = 0
    this.listaSede = []
    this.listaSeccion = []
    this._portalServices.obtenerListaSedesBackoffice(anyo, periodoId, funcionarioId).subscribe((res: any) => {
      this.listaSede = res
      if (this.filtrosCargados?.sedeId) {
        this.filtroSede = this.filtrosCargados.sedeId
        delete this.filtrosCargados.sedeId
      }
    })
  }

  obtenerSecciones(anyo: number = 0, periodoId: number = 0, sedeId: number = 0): void {
    this._reemplazoDocente.getListaSeccionesCrearReemplazoDocente(anyo, periodoId, sedeId).subscribe((res: any) => {
      this.listaSeccion = res
      if (this.filtrosCargados?.seccionId) {
        this.filtroSeccion = this.filtrosCargados.seccionId
        delete this.filtrosCargados.seccionId
      }
    })
  }

  fechaValidaEliminar(reemplazo: IReemplazos): boolean {
    const fechaFinObj = {
      dia: reemplazo.fechaTermino.split('/')[0],
      mes: reemplazo.fechaTermino.split('/')[1],
      anyo: reemplazo.fechaTermino.split('/')[2],
    }
    const fechaFin = new Date(+fechaFinObj.anyo, +fechaFinObj.mes, +fechaFinObj.dia)
    const currDate = new Date()
    return fechaFin > currDate
  }

  actualizarLista(): void {
    this.submitted = true
    const dataDocente: any = typeof this.searchCodDocenteForm.getRawValue() === 'object' ? this.searchCodDocenteForm.getRawValue() : this.searchNombreDocenteForm.getRawValue()
    if ( this.filtroAnyo === 0 ) this.tieneErrores["anyo"] = true
    if ( this.filtroPeriodo === 0 ) this.tieneErrores["periodo"] = true
    if ( this.filtroSede === 0 && !this.rolDaraCentral ) this.tieneErrores["sede"] = true
    if ( dataDocente?.funcionarioId == undefined ) this.tieneErrores["idDocente"] = true
    const filtrosConErrores = Object.values(this.tieneErrores).filter(value => value === true)
    if ( filtrosConErrores.length > 0 ) {
      return
    }
    this.renderTable = false
    this._reemplazoDocente.getListaSeccionesReemplazoDocente(this.filtroAnyo, this.filtroPeriodo, this.filtroSede, this.filtroSeccion, dataDocente.funcionarioId).subscribe(
      (res: IListaSeccionesReemplazoDocente) => {
        this.listaSeccionesDocente = res
        this.listaSeccionesDocente.forEach((seccion: IObjSeccionReemplazoDocente) => {
          if ( this.activarTodos ) {
            seccion.checked = true
          } else {
            seccion.checked = false
          }
        })
        this.renderTable = true
      }, err => {
        this.listaSeccionesDocente = []
        this.renderTable = true
      }
    )
  }

  mostrarInfoModal(titulo: string = '', texto: string = ''): void {
    this.infoModalTitulo = titulo
    this.infoModalTexto = texto
    document.getElementById('btn-modal-info')?.click()
  }

  fnAviso(dataDocente: any, docenteReemplazo: any): boolean {
    let retorno: boolean = true
    if ( dataDocente?.funcionarioId === docenteReemplazo?.funcionarioId ) {
      this.tieneErrores["idDocenteReemplazo"] = true
      this.mostrarInfoModal('Aviso', 'El ID del docente reemplazante no puede ser igual al docente a reemplazar')
      retorno = false
    }

    if ( this.listaSeccionesDocente.length === 0 ) {
      window.scrollTo(0, 0)
      this.mostrarInfoModal('Aviso', 'Debe buscar un docente a reemplazar')
      retorno = false
    }
    return retorno
  }

  crearReemplazoDocente() {
    this.submitted = true
    let reqBodyCrearReemplazoDocente: IReqBodyCrearReemplazoDocente = []
    const dataDocente: any = typeof this.searchCodDocenteForm.getRawValue() === 'object' ? this.searchCodDocenteForm.getRawValue() : this.searchNombreDocenteForm.getRawValue()
    const docenteReemplazo: any = typeof this.searchCodDocenteReemplazoForm.getRawValue() === 'object' ? this.searchCodDocenteReemplazoForm.getRawValue() : ''
    
    if ( docenteReemplazo?.funcionarioId == undefined ) this.tieneErrores["idDocenteReemplazo"] = true
    if ( this.fechaInicioDocenteReemplazo.toString() === '' ) this.tieneErrores["fechaInicioDocenteReemplazo"] = true
    if ( this.fechaFinDocenteReemplazo.toString() === '' ) this.tieneErrores["fechaFinDocenteReeemplazo"] = true
    const filtrosConErrores = Object.values(this.tieneErrores).filter(value => value === true)
    if ( filtrosConErrores.length > 0 ) {
      return
    }

    if ( !this.fnAviso(dataDocente, docenteReemplazo) ) {
      return
    }

    this.listaSeccionesDocente.forEach((seccion: IObjSeccionReemplazoDocente) => {
      if ( seccion.checked === true ) {
        reqBodyCrearReemplazoDocente.push({
          anyo: +this.filtroAnyo,
          periodoId: seccion.idPeriodo,
          sedeId: seccion.sedeId,
          descSede: seccion.descSede,
          codigoJornada: seccion.jornada,
          jornadaDesc: seccion.jornadaDesc,
          idSeccion: seccion.idSeccion,
          descSeccion: seccion.seccion,
          idDocente: dataDocente.funcionarioId,
          nombreDocente: `${dataDocente.primerNombre} ${dataDocente.apellidoPat} ${dataDocente.apellidoMat}`,
          idDocenteReemplazo: docenteReemplazo.funcionarioId,
          nombreDocenteReemplazo: `${docenteReemplazo.primerNombre} ${docenteReemplazo.apellidoPat} ${docenteReemplazo.apellidoMat}`,
          asignaturaId: seccion.asignaturaId,
          codigoAsignatura: seccion.asignaturaCodigo,
          descAsignatura: seccion.descAsignatura,
          descModalidad: seccion.modalidad,
          fechaInicio: `${this.fechaInicioDocenteReemplazo.toString().split('-')[2]}/${this.fechaInicioDocenteReemplazo.toString().split('-')[1]}/${this.fechaInicioDocenteReemplazo.toString().split('-')[0]}`,
          fechaTermino: `${this.fechaFinDocenteReemplazo.toString().split('-')[2]}/${this.fechaFinDocenteReemplazo.toString().split('-')[1]}/${this.fechaFinDocenteReemplazo.toString().split('-')[0]}`,
          tpoJornadaId: seccion.tpoJornadaId,
          metodoFormacionId: seccion.metodoFormacionId
        })
      }
    })

    if ( filtrosConErrores.length === 0 && reqBodyCrearReemplazoDocente.length === 0 ) {
      this.mostrarInfoModal('Aviso', 'Debe seleccionar al menos una sección para crear un reemplazo')
      return
    }
    // fechaInicio: new Date(this.fechaInicioDocenteReemplazo.toString().replace(/-/g, '\/')),
    this._reemplazoDocente.postCrearReemplazoDocente(reqBodyCrearReemplazoDocente).subscribe(
      (res: IResCrearReemplazoDocente) => {
        if ( res.error === null ) {
          this.router.navigate(['/reemplazo-docente-inicio'], {
            state: {
              data: {
                reemplazoDocenteCreado: true,
                nombreDocente: `${dataDocente.primerNombre} ${dataDocente.apellidoPat} ${dataDocente.apellidoMat}`
              }
            }
          })
        } else {
          this.mostrarInfoModal('Aviso', res.error?.mensaje ?? 'Hubo un error en los servicios')
        }
      }
    )
  }

  navToPortalDocente(): void {
    const dataDocente: any = typeof this.searchCodDocenteForm.getRawValue() === 'object' ? this.searchCodDocenteForm.getRawValue() : this.searchNombreDocenteForm.getRawValue()
    this.router.navigate(['/portal-calificacion'], {
      state: {
        data: {
          filtros: {
            anyo: this.filtroAnyo,
            periodoId: this.filtroPeriodo,
            sedeId: this.filtroSede,
            docenteId: dataDocente.funcionarioId, // 14599215
            seccionId: this.filtroSeccion,
            dataDocente: dataDocente
          }
        }
      }
    })
  }

  navToInicioReemplazoDocente(): void {
    this.router.navigate(['/reemplazo-docente-inicio'])
  }

  camposRequeridos(): boolean {
    const dataDocente: any = this.searchCodDocenteForm.getRawValue()
    return this.filtroAnyo !== 0 && this.filtroPeriodo !== 0 && (typeof dataDocente === 'object')
  }

  toggleActivarTodos() {
    this.listaSeccionesDocente.forEach((seccion: IObjSeccionReemplazoDocente) => {
      if ( this.activarTodos ) {
        seccion.checked = true
      } else {
        seccion.checked = false
      }
    })
  }

}
